module.exports = __webpack_public_path__ + "static/Babel-144b7aa1c3cd124be63c91c8456543c1.svg";